import type { SvgIconProps } from '@ori-ui/mui';
import { SvgIcon } from '@ori-ui/mui';

export function Other(props: SvgIconProps) {
  return (
    <SvgIcon
      fill-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      clip-rule="evenodd"
      {...props}
    >
      <g transform="matrix(0.0429687,0,0,0.0429687,1,1)">
        <g>
          <g>
            <path
              d="M502,92.5L10,92.5C4.478,92.5 0,96.978 0,102.5L0,409.5C0,415.022 4.478,419.5 10,419.5L502,419.5C507.522,419.5 512,415.022 512,409.5L512,102.5C512,96.978 507.522,92.5 502,92.5ZM492,399.5L20,399.5L20,112.5L492,112.5L492,399.5Z"
              style={{ fillRule: 'nonzero' }}
            />
            <path
              d="M298.667,315.5C298.667,345.827 323.34,370.5 353.667,370.5C362.633,370.5 371.331,368.344 379.167,364.229C387.003,368.344 395.701,370.5 404.667,370.5C434.994,370.5 459.667,345.827 459.667,315.5C459.667,285.173 434.994,260.5 404.667,260.5C395.701,260.5 387.003,262.656 379.167,266.771C371.331,262.656 362.633,260.5 353.667,260.5C323.34,260.5 298.667,285.173 298.667,315.5ZM404.819,295.32C402.862,290.331 400.145,285.58 396.801,281.388C399.36,280.799 401.994,280.499 404.667,280.499C423.966,280.499 439.667,296.2 439.667,315.499C439.667,334.798 423.966,350.5 404.667,350.5C401.994,350.5 399.359,350.2 396.801,349.611C408.917,334.426 411.887,313.346 404.819,295.32ZM379.167,291.562C385.2,297.99 388.667,306.518 388.667,315.5C388.667,324.482 385.2,333.01 379.167,339.438C373.134,333.009 369.667,324.481 369.667,315.5C369.667,306.519 373.134,297.99 379.167,291.562ZM352.659,333.349C354.668,339.197 357.673,344.773 361.533,349.612C358.975,350.2 356.34,350.5 353.667,350.5C334.368,350.5 318.667,334.799 318.667,315.5C318.667,296.201 334.368,280.5 353.667,280.5C356.34,280.5 358.975,280.8 361.533,281.389C361.401,281.555 361.279,281.728 361.149,281.895C349.943,296.403 346.702,316.01 352.659,333.349Z"
              style={{ fillRule: 'nonzero' }}
            />
            <path
              d="M244.667,339.5L66.667,339.5C61.145,339.5 56.667,343.978 56.667,349.5C56.667,355.022 61.145,359.5 66.667,359.5L244.667,359.5C250.189,359.5 254.667,355.022 254.667,349.5C254.667,343.978 250.189,339.5 244.667,339.5Z"
              style={{ fillRule: 'nonzero' }}
            />
            <path
              d="M244.667,282.5L199.667,282.5C194.145,282.5 189.667,286.978 189.667,292.5C189.667,298.022 194.145,302.5 199.667,302.5L244.667,302.5C250.189,302.5 254.667,298.022 254.667,292.5C254.667,286.978 250.189,282.5 244.667,282.5Z"
              style={{ fillRule: 'nonzero' }}
            />
            <path
              d="M53.667,228.5C53.667,234.022 58.145,238.5 63.667,238.5L367.667,238.5C373.189,238.5 377.667,234.022 377.667,228.5C377.667,222.978 373.189,218.5 367.667,218.5L63.667,218.5C58.145,218.5 53.667,222.978 53.667,228.5Z"
              style={{ fillRule: 'nonzero' }}
            />
            <path
              d="M405.667,238.5L445.667,238.5C451.189,238.5 455.667,234.022 455.667,228.5C455.667,222.978 451.189,218.5 445.667,218.5L405.667,218.5C400.145,218.5 395.667,222.978 395.667,228.5C395.667,234.022 400.145,238.5 405.667,238.5Z"
              style={{ fillRule: 'nonzero' }}
            />
            <path
              d="M60.667,197.5L121.667,197.5C127.189,197.5 131.667,193.022 131.667,187.5L131.667,145.5C131.667,139.978 127.189,135.5 121.667,135.5L60.667,135.5C55.145,135.5 50.667,139.978 50.667,145.5L50.667,187.5C50.667,193.022 55.145,197.5 60.667,197.5ZM70.667,155.5L111.667,155.5L111.667,177.5L70.667,177.5L70.667,155.5Z"
              style={{ fillRule: 'nonzero' }}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
